import { Box, Button, Icon, Typography } from "@mui/material";
import Icons from "../../../assets/js/Icons";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";

function Confirmation() {
  const navigate = useNavigate();
  const { specialist } = useSelector((state) => state.authSlice); 

  useEffect(() => {
    if (specialist?.verification?.status === "verified") {
      navigate("/specialist/profile", { replace: true });
    }
  }, [specialist?.verification?.status, navigate]);
  return (
    <Box
      sx={{
        p: 3,
        border: "1px solid #3498db",
        borderTop: "none",
        borderRadius: "0 0 6px 6px",
      }}
    >
      <Box
        sx={{
          p: 3,
          gap: 3,
          mx: "auto",
          borderRadius: 1,
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          border: "1px solid #dedede",
          maxWidth: { xs: "100%", sm: "80%", lg: "40%" },
        }}
      >
        <Icon sx={{ fontSize: "50px", overflow: "visible", color: "#3bb54a" }}>
          <Icons.Checkmark />
        </Icon>
        <Typography fontSize={20} fontWeight="700" textAlign="center">
          Your Profile Has Been Submitted successfully and It's Under Review
        </Typography>
      </Box>

      <Typography
        mb={2}
        fontSize={36}
        component="h2"
        fontWeight="700"
        color="other.color1"
      >
        Approval and Activation Confirmation
      </Typography>
      <Typography
        mb={1.7}
        fontSize={24}
        component="h4"
        fontWeight="600"
        color="other.color1"
      >
        Thank You for Completing Your Profile!
      </Typography>
      <Typography mb={1.7} fontWeight="500" color="#7A8A9E">
        We appreciate your dedication to creating a detailed profile. Our admin
        team will now review your information and conduct a background check.
        Once approved, your profile will be live, and you'll be ready to connect
        with clients on InnerPal.
      </Typography>
      <Typography mb={1.7} color="#7A8A9E">
        Welcome Aboard! Your profile is now live, and you're ready to connect
        with clients. Start your journey with InnerPal Next Steps Guide
      </Typography>
      <Typography
        mb={1.7}
        fontSize={24}
        component="h4"
        fontWeight="600"
        color="other.color1"
      >
        Here's what happens next:
      </Typography>
      <Box component="ol">
        <Typography color="#7A8A9E" component="li">
          Profile Review: "Our team will carefully review your profile to ensure
          it meets our standards."
        </Typography>
        <Typography color="#7A8A9E" component="li">
          Background Check: "A standard background check will be conducted to
          maintain the trust and safety of our community."
        </Typography>
        <Typography color="#7A8A9E" component="li">
          Activation Notification: "Upon approval, you’ll receive an email
          confirming that your profile is live on InnerPal."
        </Typography>
      </Box>

      <Button
        sx={{
          py: 1.2,
          minWidth: "110px",
          justifyContent: "center",
        }}
        variant="contained"
        LinkComponent={Link}
        to="/community-forums"
      >
        Forums
      </Button>
    </Box>
  );
}

export default Confirmation;
